/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Time/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import Type from './Type/index'
import Value from './Value/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Time({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/Wait/Time"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Time.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-btyT': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<Value
  viewPath={`${viewPath}/Value`}
/>
<Type
  viewPath={`${viewPath}/Type`}
/>
</div>
{children}
</React.Fragment>)
}